/**
 * Where a deep link was headed when sign-in interrupted it, so the app can go back there after the
 * sign-in round trip instead of to the last board.
 */

// Start-up and sign-in routes: returning to one of these would loop or show nothing.
const nonReturnablePrefixes = ["/loading", "/auth", "/signin", "/signup", "/login", "/regions", "/teams-auth"];

/** An in-app path that is safe to navigate back to after sign-in. */
export const isReturnablePath = (path: unknown): path is string => {
  if (typeof path !== "string" || !path.startsWith("/") || path === "/") {
    return false;
  }

  // "//host" and "/\host" are read by browsers as another origin.
  if (path.startsWith("//") || path.startsWith("/\\")) {
    return false;
  }

  const pathname = path.split(/[?#]/)[0].toLowerCase();
  return !nonReturnablePrefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};

/** The current location as a return path, or undefined when there is nothing worth returning to. */
export const currentReturnPath = (): string | undefined => {
  const { pathname, search, hash } = window.location;
  const path = `${pathname}${search}${hash}`;
  return isReturnablePath(path) ? path : undefined;
};
